module.exports = __webpack_public_path__ + "img/9788932908717.df08407b.jpg";